import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import RestError from '../../../modules/app/errors';
import Button from '../../../components/common/Button';
import { close as closeModal } from '../../../modules/modal/actions';
import contentStackImageUrls from '../../../../resources/contentStackImageUrls.json';

const { plusCard } = contentStackImageUrls;

const modelButton = (close) => <Button className="modal__button" onClick={close}>Back</Button>;
export const CardNumberRegistered = ({ close, error }) => (
  <div className="modal card-number-registered">
    {error.status === 404
    && (
      <div>
        <img
          src={plusCard}
          onError={(e) => { e.target.src = '../../../../assets/images/landing/plus-card.png'; }}
          className="card-number-registered__image"
        />
        <p className="card-number-registered__paragraph">
          Enter a 16 digit PLUS card number in order to activate.
        </p>
        {modelButton(close)}
      </div>
    )
    }
    {error.status === 409
    &&    (
      <div>
        <img
          src={plusCard}
          onError={(e) => { e.target.src = '../../../../assets/images/landing/plus-card.png'; }}
          className="card-number-registered__image"
        />
        <h2 className="card-number-registered__header">PLUS Card Number Already Registered.</h2>
        {modelButton(close)}
      </div>
    )
    }
  </div>
);

CardNumberRegistered.propTypes = {
  close: PropTypes.func.isRequired,
  error: RestError
};

const mapDispatchToProps = {
  close: closeModal
};

export default connect(null, mapDispatchToProps)(CardNumberRegistered);
